jQuery(function ($) {
    'use strict'

    new SliderManager();
    new DialogManager();
    new CartManager();
    new ExternalLinkManager();
    new VisibilityManager();
    new VatValidationManager();

    const distributorManager = new DistributorManager();
    distributorManager.loadDistributors();

    $('button[aria-controls="AddAddress"]').on('click', function (e) {
        $('#AddAddress').slideToggle();
    })

    $('button[id^="EditFormButton"]').on('click', function (e) {
        const parentLi = $(this).closest('li');
        const editAddressDiv = parentLi.find('div[id^="EditAddress"]');

        editAddressDiv.slideToggle();
    })

    $('#CustomerEmail').focus();

    $('.page-konto .rich-text__buttons a').attr('tabindex', '5');
})